module.exports = __webpack_public_path__ + "img/c05_buildingtechauxiliacampupgrade2_Normal_ua.3a2dfd38.webp";